import { useState, useEffect } from "react";

import { db } from "../../util/firebase";
import { query, collection, getDocs, where } from "firebase/firestore";

import { useNavigate, useParams } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft } from "react-icons/fa";

function NewsArticlePage() {
  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const params = useParams();
  const articleId = params.articleId;
  console.log(articleId);

  // eslint-disable-next-line
  const [newsArticle, setNewsArticle] = useState();
  const fetchNewsArticle = async () => {
    try {
      setIsLoading(true);

      const q = query(
        collection(db, "newsArticles"),
        where("uid", "==", articleId)
      );
      const doc = await getDocs(q);
      // eslint-disable-next-line
      const data = doc.docs[0]?.data();

      console.log(data);

      setNewsArticle(data);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching news article");
    }
  };

  useEffect(() => {
    fetchNewsArticle();
    // eslint-disable-next-line
  }, []);

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="newsArticlePage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        ARTICLE
      </h1>
      <div>
        <div id="newsArticleImageContainer">
          <img
            alt="newsArticleImage"
            src={
              newsArticle?.image
                ? newsArticle?.image
                : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
            }
            id="newsArticleImage"
          />
        </div>
        <p id="newsArticleTitle">{newsArticle?.title}</p>
        <p id="newsArticleText">{newsArticle?.text}</p>
      </div>
    </div>
  );
}

export default NewsArticlePage;
